// import data from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
	    top: isMobile ? 100 : 70, // More top margin for legends with 5px spacing
	    right: isMobile ? 2 : 10, // Minimal right margin
	    bottom: isMobile ? 50 : 40, // Reduced bottom margin
	    left: isMobile ? 25 : 45, // Reduced left margin
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    height,
    initialWidth,
    initialHeight,
    margins,
    width,
  };
}
